import axios from "axios";

const Api = {
  local: `http://localhost:5000`,
  // test: `https://caff-api.dev-ped.com`,
  prod: `https://caff-api.dev-ped.com`,
};

function getApiBaseUrl() {
  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    console.log('localhost detected');
    return Api.local;
  }

  // สมมติว่า port 9824 เป็นของ test ตามตัวอย่าง
  if (hostname === "m.pumpuibrand.co.th" && window.location.port === "9824") {
    console.log('Test environment detected');
    return Api.test;
  }

  // สมมติว่า port 4289 เป็นของ prod ตามตัวอย่าง
  if (hostname === "caff.dev-ped.com") {
    console.log('Production environment detected');
    return Api.prod;
  }

  console.log('Defaulting to local environment');
  return Api.local;
}

export const API_BASE_URL = getApiBaseUrl();

export const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  const branchId = localStorage.getItem("selected_branch_id");
  if (branchId) {
    config.headers['X-Branch-Id'] = branchId;
  }
  
  return config;
});
